import React from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ModalRemoveItem = props => {
  const {
    handleModalClose,
    handleModalConfirmYes,
    showModal,
    titleModal,
    bodyModal,
    nameItemWillRemove
  } = props;

  return (
    <React.Fragment>
      <Modal show={showModal} onHide={handleModalClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>{titleModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bodyModal}{' '}
          <Badge variant="dark" className="">
            <h5 className="m-1">{nameItemWillRemove}</h5>
          </Badge>{' '}
          ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            <i className="fa fa-arrow-left"></i>
            &nbsp;Voltar
          </Button>
          <Button variant="danger" onClick={handleModalConfirmYes}>
            <i className="fa fa-trash"></i>
            &nbsp;Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

ModalRemoveItem.propTypes = {
  handleModalClose: PropTypes.func,
  handleModalConfirmYes: PropTypes.func,
  showModal: PropTypes.bool,
  titleModal: PropTypes.string,
  bodyModal: PropTypes.string,
  nameItemWillRemove: PropTypes.string
};

export default ModalRemoveItem;
